type OverlayListener = () => void;

const listeners = new Set<OverlayListener>();

const requestShortcutsOverlay = (): void => {
	for (const listener of listeners) listener();
};

const subscribeShortcutsOverlay = (listener: OverlayListener): (() => void) => {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
};

const shortcutsOverlayControl = {
	request: requestShortcutsOverlay,
	subscribe: subscribeShortcutsOverlay
};

export default shortcutsOverlayControl;
